import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_8saruzc4vt: FaireCollectionEntity = {
  token: "pbc_8saruzc4vt",
  type: "collection",
  name: "fruit",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7d2968c63fa5a6af5f5258c8ba19413060690425f351e059fc0c46ddf9f7072b.jpeg",
  itemCount: 23,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.136Z",
    importedBy: "entity-db-import-collections",
  },
};
